import { Node } from '../types';

// Check if string is mongodb id https://stackoverflow.com/questions/13850819/can-i-determine-if-a-string-is-a-mongodb-objectid
export const isMongoId = (data: string) => data.match(/^[0-9a-fA-F]{24}$/) ? null : data;

/**
 * Find node with field data value and return data if nothing is found
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const findNode = (nodes: Node[], data: string) => nodes.find((node) => node.id === data)?.name ?? isMongoId(data);

export default findNode;
